<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Ready
</vuejs3-todo>

<template>
    <section class="action-page">
        <p v-if="feedback.type"
           :class="['label-feedback', feedback.type]"
        >{{ feedback.message }}</p>
        <template v-else>
            <button v-for="status in statuses"
                    :key="status"
                    @click="declare(status)"
            >{{ i18n.statuses[status] }}</button>
        </template>
    </section>
</template>

<script>
    import axios from "@/outside/axios";

    const i18n = {
        de: {
            statuses: {
                finished: "Aktion erledigt!",
                in_progress: "Aktion in Arbeit"
            },
            success: "Information übertragen!"
        },
        en: {
            statuses: {
                finished: "Action done!",
                in_progress: "Action in progress"
            },
            success: "Information transmitted!"
        },
        fr: {
            statuses: {
                finished: "Action réalisée !",
                in_progress: "Action en cours de réalisation"
            },
            success: "L'information est transmise !"
        }
    };

    export default {
        computed: {
            /**
             * @return {Object}
             */
            i18n() {
                return this.$i18n.strings(i18n, this.$options.name);
            },
            /**
             * @return {string[]}
             */
            statuses() {
                // Warning! Order is important
                return ["in_progress", "finished"];
            }
        },
        data() {
            return {
                feedback: {
                    message: null,
                    type: null
                }
            };
        },
        methods: {
            /**
             * Sends action status update request to Echoline API.
             * @param {String} status
             * @return {Promise}
             */
            declare(status) {
                return axios.post("/rpc", {
                    action: "actions.declare",
                    params: {
                        action: this.actionid,
                        declare: status
                    }
                }, {
                    validateStatus: (status => status === 200)
                }).then(() => {
                    this.feedBack("success", this.i18n.success);
                }).catch(() => {
                    this.feedBack("error", this.i18n._error);
                });
            },
            /**
             * Displays feedback info.
             * @param {string} type
             * @param {string} message
             * @return {void}
             */
            feedBack(type, message) {
                if (typeof type !== "string") {
                    throw new TypeError(`ActionPage.feedBack() method expects parameter 1 to be a string, ${typeof type} given`);
                }

                if (!["error", "success"].includes(type)) {
                    throw new TypeError(`ActionPage.feedBack() method expects parameter 1 to be either 'error' or 'success', '${type}' given`);
                }

                if (typeof message !== "string") {
                    throw new TypeError(`ActionPage.feedBack() method expects parameter 2 to be a string, ${typeof message} given`);
                }

                this.feedback.type = type;
                this.feedback.message = message.trim();
            }
        },
        name: "ActionPage",
        props: {
            actionid: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss">
    @import "../../mixins";
    @import '../../colors';

    .action-page {
        display: flex;
        height: 100vh;
        width: 100vw;
        align-items: center;
        justify-content: center;
        gap: 16px;
        background-image: url("/img/outside_action-page_background.svg");
        background-repeat: no-repeat;
        background-position: bottom left;
        background-size: 32%;

        button {
            line-height: 54px;
            border: 1px solid $color-mint;
            background-color: $color-mint;
            appearance: none;
            cursor: pointer;
            padding: 0 16px;
            font-size: inherit;
            font-family: inherit;
            border-radius: 8px;
            color: white;
            width: 24%;
            @include transition(background-color, color);

            &:hover {
                background-color: transparent;
                color: $color-mint;
            }
        }

        & > p {
            margin: 0 auto;
            width: 40%;
            line-height: 56px;
            text-align: center;
            border-radius: 8px;

            &.success {
                background-color: $color-green-dark;
            }

            &.error {
                background-color: $color-red-dark;
                color: white;
            }
        }
    }
</style>
